import { Navigate, Route, Routes, useNavigate } from 'react-router';
import NotFoundPage from '@src/pages/NotFound.page';
import NifOrderLayout from './components/NifOrderLayout';
import { useNifOrderFlow } from './hooks/useNifOrderFlow';
import NifPrepareDocumentsPage from './steps/0-prepare-documents.page';
import NifPersonalDetailsPage from './steps/1-personal-details.page';
import { NifOrderStepPageWithOptionalOrderProps } from './types/stepProps';

function NewNifOrderPage(): JSX.Element {
  const flowResult = useNifOrderFlow({ isNew: true });
  const navigate = useNavigate();

  if (flowResult.type === 'loading') {
    // shouldn't happen
    return <div />;
  }

  if (flowResult.type === 'redirect') {
    return <Navigate replace to={flowResult.to} />;
  }

  const stepProps: NifOrderStepPageWithOptionalOrderProps = {
    previousUrl: flowResult.previousUrl,
    getNextUrl: flowResult.getNextUrl,
  };

  return (
    <Routes>
      <Route
        element={
          <NifOrderLayout
            onExitClick={() => navigate('/')}
            steps={flowResult.categoryItems}
            headerName={flowResult.currentCategoryName}
          />
        }
      >
        <Route
          path="prepare-documents"
          element={<NifPrepareDocumentsPage {...stepProps} />}
        />
        <Route
          path="personal-details"
          element={<NifPersonalDetailsPage {...stepProps} />}
        />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default NewNifOrderPage;
